import { render, staticRenderFns } from "./StatusToggle.vue?vue&type=template&id=e6d16454&"
import script from "./StatusToggle.vue?vue&type=script&lang=ts&"
export * from "./StatusToggle.vue?vue&type=script&lang=ts&"
import style0 from "./StatusToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6d16454')) {
      api.createRecord('e6d16454', component.options)
    } else {
      api.reload('e6d16454', component.options)
    }
    module.hot.accept("./StatusToggle.vue?vue&type=template&id=e6d16454&", function () {
      api.rerender('e6d16454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/StatusToggle.vue"
export default component.exports